import type { Pack } from "@/modules/corporate/types/pricing"
import type { FunctionComponent, HTMLAttributes } from "react"

import { clsx } from "clsx"

import { Badge } from "@jobteaser/spark/components/Badge"
import { StarFilled } from "@jobteaser/spark/components/Icons/StarFilled"
import { Text } from "@jobteaser/spark/components/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./ThPackHeading.module.css"

type ThPackHeadingProps = {
  className?: string
  pack: Pack
} & HTMLAttributes<HTMLTableCellElement>

export const ThPackHeading: FunctionComponent<ThPackHeadingProps> = ({ className, pack, ...restProps }) => {
  const { t } = useTranslation(["corporate"])
  const mainClassNames = clsx(styles.main, className)

  return (
    <th {...restProps} className={mainClassNames} scope="col">
      <div className={styles.thWrapper}>
        <Text className={styles.title} variant="title3" weight="bold">
          {t(pack.title)}
        </Text>
        {pack.recommended && (
          <Badge className={styles.thBadge} icon={StarFilled} variant="primary">
            {t("corporate.common.recommended")}
          </Badge>
        )}
        <Text variant="body1" weight="regular">
          {t(pack.description)}
        </Text>
      </div>
    </th>
  )
}
